import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, ChevronRight } from "lucide-react";
import { useApp, t } from "@/lib/AppContext";
import { api, resolveImg } from "@/lib/api";
import SectionLabel from "@/components/SectionLabel";
import SEOHead from "@/components/SEOHead";

export default function Blog() {
  const { content, settings } = useApp();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/news").then(r => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  const bg = settings?.bg_image_urls?.blog;
  return (
    <div data-testid="blog-page">
      <SEOHead title="Новости из Европы" description="Свежие новости автомобильного рынка Европы" />
      <section className="relative py-16 md:py-24 section-on-dark">
        <div className="absolute inset-0">
          {bg && <img src={resolveImg(bg)} alt="" className="w-full h-full object-cover" />}
          <div className="absolute inset-0" style={{ background: "rgba(28,58,107,0.85)" }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <SectionLabel light>{t(content, "blog.label", "Новости")}</SectionLabel>
          <h1 className="section-heading text-white mt-4">{t(content, "blog.title", "Новости из Европы")}</h1>
          <p className="text-white/75 mt-3 max-w-2xl">{t(content, "blog.subtitle", "Свежие новости автомобильного рынка")}</p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-[var(--color-bg-primary)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1,2,3].map(i => <div key={i} className="skeleton h-72" />)}
            </div>
          ) : items.length === 0 ? (
            <div className="text-center py-16 bg-white rounded-[var(--radius-lg)]">
              <div className="text-[var(--color-text-secondary)]">Скоро здесь появятся первые статьи</div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map(n => (
                <Link key={n.id} to={`/blog/${n.slug}`} className="car-card hover:shadow-xl group" data-testid={`news-card-${n.slug}`} style={{ borderTop: "2px solid var(--color-secondary)" }}>
                  <div className="aspect-[16/10] bg-gray-100 overflow-hidden">
                    {n.cover_url ? <img src={resolveImg(n.cover_url)} alt={n.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform" /> : <div className="w-full h-full flex items-center justify-center text-gray-300">Без обложки</div>}
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <div className="flex items-center gap-2 text-xs text-[var(--color-text-secondary)] mb-2">
                      <Calendar size={12} /> {new Date(n.published_at).toLocaleDateString("ru-RU")}
                    </div>
                    <h3 className="font-headings font-bold text-lg leading-tight mb-2 group-hover:text-[var(--color-primary)] transition-colors">{n.title}</h3>
                    <p className="text-sm text-[var(--color-text-secondary)] line-clamp-3 flex-1">{n.excerpt}</p>
                    <div className="mt-4 inline-flex items-center gap-1 text-xs font-accent uppercase tracking-wider text-[var(--color-secondary)]">Читать <ChevronRight size={14} /></div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
